import { render, staticRenderFns } from "./NotificationDialog.vue?vue&type=template&id=e8cc32e8&scoped=true"
import script from "./NotificationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NotificationDialog.vue?vue&type=style&index=0&id=e8cc32e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_css-loader@6.11.0_webpack@5.109.2_cssnano@5.1.15__txhfkviks3ummxta33hlcz7ciy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8cc32e8",
  null
  
)

export default component.exports